import gql from 'graphql-tag';
import { apollo } from 'src/features';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation CreateActivity($channelIdentifier: String!) {
  createActivity(channelIdentifier: $channelIdentifier) {
    id
  }
}`;

function createActivity(channelIdentifier) {
  return apollo.client.mutate({
    mutation,
    variables: {
      channelIdentifier,
    },
  }).then((res) => (res.data.createActivity.id))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default createActivity;
